export default __webpack_public_path__ + "static/media/cv_css.f1895bfa.png";